var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSearch = function SvgSearch(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.1151937,98.1192011 C95.6021193,100.626933 91.8325074,100.626933 89.3194331,98.1192011 L69.8431043,78.6842799 C52.879851,91.2229386 29.6339109,90.5960061 13.9271946,76.1765486 C-3.66432759,59.8762922 -4.92086493,31.0373774 12.0423887,13.4832554 C29.0056424,-4.07086671 57.2777317,-4.69779967 74.8692537,12.8563224 C90.5759699,28.5296456 91.8325074,52.98003 78.6388656,69.9072193 L98.1151943,89.3421399 C100.628269,91.8498717 100.628269,95.6114692 98.1151937,98.1192011 Z M68.8880597,25.0990099 C56.3507462,7.63366338 30.6492536,7.63366338 18.1119403,25.0990099 C9.96268658,35.7029703 9.96268658,51.2970297 18.1119403,61.90099 C30.6492536,79.3663367 56.3507462,79.3663367 68.8880597,61.90099 C77.0373134,50.6732673 77.0373134,35.7029702 68.8880597,25.0990099 Z"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "search.7bd9b7270aaaf7352fd78e905641ffa5.svg";